import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { animated, useSpring } from "react-spring";
import { io, Socket } from "socket.io-client";

interface SoundEvent {
  username: string;
  soundIndex: string;
}

const SoundWidget = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [message, setMessage] = useState<string>("");
  const [socket, setSocket] = useState<Socket | null>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const springProps = useSpring({
    transform: isVisible ? "scale(1)" : "scale(0)",
    opacity: isVisible ? 1 : 0,
    config: {
      tension: 100,
      friction: 10,
    },
  });

  useEffect(() => {
    if (!token) {
      console.error("No token provided");
      return;
    }

    // Connect to Socket.IO with token authentication
    const socketUrl =
      process.env.NODE_ENV === "development"
        ? "http://localhost:3000"
        : window.location.origin;

    const newSocket = io(socketUrl, {
      auth: { token },
    });

    newSocket.on("connect", () => {
      console.log("Sound widget connected to Socket.IO");
    });

    newSocket.on("connect_error", (error: any) => {
      console.error("Socket connection error:", error.message);
    });

    newSocket.on("updateSoundWidget", (data: SoundEvent) => {
      const { username, soundIndex } = data;
      console.log("we got a message from socket");
      setMessage(`${username} played ${soundIndex}`);
      setIsVisible(true);

      // Start zoom out animation after 4.5 seconds, then clear message
      setTimeout(() => {
        setIsVisible(false);
      }, 5500);

      setTimeout(() => {
        setMessage("");
      }, 6000);
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [token]);

  if (!token) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-transparent">
        <div className="text-red-500 text-2xl font-bold">
          Error: No token provided
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-transparent">
      {message && (
        <animated.div
          style={springProps}
          className=" w-full m-2 bg-black bg-opacity-90 backdrop-blur-sm p-6 rounded-xl border-2 border-purple-500 shadow-[0_0_20px_rgba(168,85,247,0.6)]"
        >
          <div className="text-white text-4xl font-bold text-center drop-shadow-[0_2px_4px_rgba(0,0,0,0.8)]">
            {message}
          </div>
        </animated.div>
      )}
    </div>
  );
};

export default SoundWidget;
